import { Dayjs } from 'dayjs';
import { atom } from 'jotai';
import { INIT_DOCUMENTS_SUMMARIES_DATA } from '@/recoil/init_data/documents';
import { TalkFlowAISummarizeType } from '@/types/talk_flow';

export type AiSummarizedContentUiState =
  | 'loading'
  | 'completed'
  | 'error'
  | 'validation_error';

export type AiSummarizedContent = {
  id: string;
  docId?: string;
  prompt: string;
  content: string;
  contentDom: string;
  createdAt: Dayjs;
  uiState: 'idle' | AiSummarizedContentUiState;
  summarizeType: TalkFlowAISummarizeType;
};

export type DocumentAiSummariesData = Record<string, AiSummarizedContent>;
export const DocumentAiSummariesState = atom<DocumentAiSummariesData>(
  INIT_DOCUMENTS_SUMMARIES_DATA,
);

// commonSummary(AI 요약) 재생성 상태 — docId -> 상태. 항목이 없으면 평상시(요약 표시).
// SSE talk-flow.common-summary.regenerate.{start,complete,error} 가 그대로 상태가 된다:
//   start → loading(스켈레톤) / complete → 항목 삭제 + 문서 재조회(요약 표시) / error → error(오류 문구)
// 모달을 닫았다 열어도 유지되도록 전역 atom 에 둔다(로컬 useState 는 언마운트 시 유실).
// startedAt 은 SSE 유실 대비 안전 타임아웃 계산용.
// 주의: AI 정리(organize)와는 분리한다 → 정리 실패가 AI 요약 블록을 오염시키지 않도록
//       organize 계열은 아래 OrganizeStatusState 를 사용한다.
export type CommonSummaryStatusEntry = {
  status: 'loading' | 'error';
  startedAt: number;
};
export const CommonSummaryStatusState = atom<
  Record<string, CommonSummaryStatusEntry>
>({});

// AI 정리(organize) 진행/실패 상태 — docId -> 상태. AI 요약(CommonSummaryStatusState)과 분리.
// SSE talk-flow.organize.{start,complete,error} 가 그대로 상태가 된다:
//   start → loading(본문 스켈레톤) / complete → 항목 삭제 / error → error(본문 에러 배너 + 재시도)
// 정리 실패는 본문 영역 전용 에러 배너로만 표시하고 AI 요약 블록에는 영향을 주지 않는다.
// startedAt 은 SSE 유실 대비 안전 타임아웃 계산용.
export type OrganizeStatusEntry = {
  status: 'loading' | 'error';
  startedAt: number;
};
export const OrganizeStatusState = atom<Record<string, OrganizeStatusEntry>>(
  {},
);
